import { render, staticRenderFns } from "./paivittainen-merkinta.vue?vue&type=template&id=d5d92058&scoped=true&"
import script from "./paivittainen-merkinta.vue?vue&type=script&lang=ts&"
export * from "./paivittainen-merkinta.vue?vue&type=script&lang=ts&"
import style0 from "./paivittainen-merkinta.vue?vue&type=style&index=0&id=d5d92058&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5d92058",
  null
  
)

export default component.exports